import { numeralFormatterCurrency } from 'ns_libs/formatter';
import {
    Attributes, dollarValueAttributes, percentageValueAttributes, multiplierValueAttributes,
} from '../constants';

export const getFormattedFilterValue = (filterAttribute: Attributes, filterValue?: string): string => {
    if (dollarValueAttributes.includes(filterAttribute)) {
        if (filterAttribute === Attributes.AcquisitionPrice) {
            return numeralFormatterCurrency(filterValue, '$0,0');
        }
        return numeralFormatterCurrency(filterValue);
    }
    if (percentageValueAttributes.includes(filterAttribute)) {
        // Filter values are user-entered percentages (e.g. "10" for 10%), not decimals
        return filterValue ? `${Number(filterValue).toFixed(2)}%` : '';
    }
    if (multiplierValueAttributes.includes(filterAttribute)) {
        return filterValue ? `${Number(filterValue).toFixed(4)}x` : '';
    }
    return filterValue || '';
};

export const getFormattedRangeValue = (filterAttribute: Attributes, filterRange: { from?: string; to?: string }): string => {
    const fromValue = getFormattedFilterValue(filterAttribute, filterRange.from);
    const toValue = getFormattedFilterValue(filterAttribute, filterRange.to);

    return `${fromValue} - ${toValue}`;
};
